import React, { createContext, useContext, ReactNode } from "react";

interface IndexOrderEventsProviderProps {
  children: ReactNode;
  parentId: string;
}

interface IndexOrderEventsContextValue {
  parentId: string;
}

const IndexOrderEventsContext = createContext<
  IndexOrderEventsContextValue | undefined
>(undefined);

const IndexOrderEventsProvider: React.FC<IndexOrderEventsProviderProps> = ({
  children,
  parentId,
}) => {
  return (
    <IndexOrderEventsContext.Provider value={{ parentId }}>
      {children}
    </IndexOrderEventsContext.Provider>
  );
};

const useIndexOrderEventsContext = (): IndexOrderEventsContextValue => {
  const context = useContext(IndexOrderEventsContext);
  if (!context) {
    throw new Error(
      "useIndexOrderEventsContext must be used within an IndexOrderEventsProvider"
    );
  }
  return context;
};

export { IndexOrderEventsProvider, useIndexOrderEventsContext };
